import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pl from '@/config/pl';

Vue.use(VueI18n);
const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    pl,
  },
});
export default i18n;
